import { styled as StyledMui } from "@mui/material/styles";
import { Typography, Menu, Avatar, Button, Box, MenuItem } from "@mui/material";

export const HeaderUserInfoButton = StyledMui(Button)(({ theme }) => ({
  backgroundColor: "#ffffff",
  textTransform: "capitalize",
  padding: "0.6rem 2rem",
  borderRadius: "1rem",
  "&:hover": {
    backgroundColor: "#ffffff",
    ".css-fywnj6-MuiAvatar-root": {
      border: "0.2rem solid #c8c8c8",
    },
  },
  ".MuiButton-endIcon": {
    marginRight: theme.direction === "ltr" ? "-0.4rem" : "0.8rem",
    marginLeft: theme.direction === "ltr" ? "0.8rem" : "-0.4rem",
  },
}));

export const HeaderUserInfoButtonInnerBox = StyledMui(Box)(() => ({
  display: "flex",
  gap: "1rem",
  justifyContent: "center",
  alignItems: "center",
}));

export const UserAvatar = StyledMui(Avatar)(({isHeaderShrink}) => ({
  border: "0.2rem solid #ffffff",
  width: String(isHeaderShrink) === "true" && "25px",
  height: String(isHeaderShrink) === "true" && "25px",
  "@media only screen and (max-width: 850px)": {
    width: "30px",
    height: "30px",
  },
}));

export const HeaderUserName = StyledMui(Typography)(() => ({
  color: "#484848",
  fontSize: "1.8rem",
  textWrap: "nowrap",
  whiteSpace: "nowrap",
  maxWidth: "160px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "@media only screen and (max-width: 375px)": {
    maxWidth: "90px",
  },
}));

export const StyledMenu = StyledMui((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "0.6rem",
    marginTop: theme.spacing(-0.1),
    minWidth: "18rem",
    color: "#64666A",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: "#ffffff",
      },
    },
  },
}));

export const StyledMenuItem = StyledMui(MenuItem)(({isHeaderShrink}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "baseline",
  columnGap: "1rem",
  paddingTop:String(isHeaderShrink) === "true" && "3px",
  paddingBottom:String(isHeaderShrink) === "true" && "3px"
}));
